import { ApiService } from '~/service/service.api';
import { NoteImportDto } from '~/shared/dto/admin/note.dto';
import { NoteId } from '~/shared/dto/id';
import { Model } from '~/shared/service/service.base';
import { ImportModel } from './model.import';
import { TranslationModel, Translations } from './model.translation';

type NoteRowType = Omit<InstanceType<typeof NoteImportDto>, 'id'> & Translations & { noteId: NoteId };

@Model()
export class NoteImportModel extends ImportModel<NoteImportDto> {
	constructor(
		api: ApiService,
		private readonly tr: TranslationModel,
	) {
		super(NoteImportDto, api.noteImport.bind(api));
	}

	getItemFromRow(row: NoteRowType): NoteImportDto {
		return {
			id: this.parseNumber(row.noteId) as NoteId,
			name: row.name,
			synonyms: this.parseStringArray(row.synonyms),
			active: this.parseBoolean(row.active),
			translations: this.tr.getTranslationsFromRow(row),
		};
	}

	downloadTemplate = () => {
		const example: NoteRowType = {
			noteId: 44,
			name: 'Example Note (en)',
			synonyms: ['Example', 'Sample'],
			active: true,
		};
		this.tr.addTranslationsToExample(example);
		this.buildAndDownloadCSV('note-import-template.csv', example);
	};
}
